// extracted by mini-css-extract-plugin
export default {"container":"InputText_container__6eaLH"};